module.exports = __webpack_public_path__ + "static/media/paquete3.b6930454.jpeg";